import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { BASE } from '../api/api'
import Axios from 'axios'
import { List } from 'react-content-loader'
import ReactHtmlParser from 'react-html-parser';
import Footer from '../footer/footerbkp';
import Header from '../header/newheader'
import TopBar from '../topbar/topbar'

import next from '../assets/clusternext.png'
import close from '../assets/closegrey.png'

class ClusterPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mission: '',
            tab_sel: 'overview',
            publist: [],
            theslist: [],
            eventlist: []
        }
        this.refover = React.createRef()
        this.refmember = React.createRef()
        this.refproj = React.createRef()
        this.refpub = React.createRef()
        this.refpartner = React.createRef()
        this.refthesis = React.createRef()

    }
    topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
    list() {
        Axios(BASE + 'jsonapi/node/research_cluster', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
            .then((data) => {
                this.setState({
                    mission: data.data.data
                })
            })
            .catch((err) => {
                console.log('not found')
            })
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.match.params.id !== this.props.match.params.id) {
            this.setState({
                data1: null
            })

            let link = nextProps.match.params.id
            let links = link.replace(/-/g, ' ')
            console.log('id', links)
            this.loadDetails(links)
        }
    }
    loadDetails(id) {
        Axios(`${BASE}jsonapi/node/research_cluster?filter[title]=${id}&include=field_cis_program,field_cluster_research_projects,field_events,field_publications,field_publications.field_author,field_publications.field_journal,field_publications.field_books,field_relevant_centers,field_student_theses`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
            .then((data) => {

                this.setState({
                    data1: data.data
                })
                if (this.state.data1)
                    console.log('datas', this.state.data1)
                var elmnt1 = document.querySelectorAll('.center_accordion ul');
                var elmnt2 = document.querySelectorAll('.center_accordion h2');

                elmnt1[elmnt1.length - 1].classList.add("bord-bottom")
                elmnt2[elmnt2.length - 1].classList.add("bord-bottom")

                document.querySelectorAll('.center_accordion h2').forEach(function (el) {
                    if (el.innerHTML == '&nbsp;' || el.innerHTML == '') {
                        el.parentNode.removeChild(el);
                    }
                });
                document.querySelectorAll('.center_accordion h2').forEach(function (el, ind) {
                    console.log(ind)
                    //  if(ind===elmnt1.length-1){
                    //     el.classList.add("bord-bot");
                    // }
                    el.onclick = function () {
                        if (el.classList.contains("active")) {
                            el.classList.remove("active");
                            el.nextElementSibling.style.display = 'none';
                            el.nextElementSibling.classList.remove("active");
                            document.querySelectorAll('.center_accordion h2').forEach(function (el) {
                                el.classList.remove("active");
                            });
                        }
                        else {
                            document.querySelectorAll('.center_accordion ul').forEach(function (el) {
                                el.style.display = 'none';
                            });
                            document.querySelectorAll('.center_accordion h2').forEach(function (el) {
                                el.classList.remove("active");
                            });
                            el.classList.add("active");
                            el.nextElementSibling.style.display = 'block';
                            el.nextElementSibling.classList.add("active");

                        }
                    };
                });
            })
            .catch((err) => {
                console.log('not found')
            })
    }
    componentWillMount() {
        this.list()
        let link = this.props.match.params.id
        let linked = link.replace(/-/g, ' ')
        let links = linked.replace(/&/g, '%26')
        console.log('ids', links)
        this.loadDetails(links)
        this.topFunction();
        //ResrchDiviison
    }
    checkThesis(eventarray, id) {
        let arr = eventarray.map(a => a.id);
        var a = arr.indexOf(id);
        if (a !== -1)
            return false
        else
            return true
    }
    scrollToTargetAdjusted(id) {
        var element = document.getElementById(id);
        var headerOffset = 70;
        var elementPosition = element.getBoundingClientRect().top;
        var offsetPosition = elementPosition - headerOffset;
        // this.setState({
        //     tab_sel: id
        // })

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }
    checkPub(eventarray, id) {
        let arr = eventarray.map(a => a.id);
        var a = arr.indexOf(id);
        if (a !== -1)
            return false
        else
            return true
    }
    render() {
        let link = this.props.match.params.id
        let links = link.replace(/-/g, ' ')
        const cluster = [
            { name: 'Critical Issues in Islamic Studies', link: process.env.PUBLIC_URL + '/cluster/c1.png' },
            { name: 'Islamic Finance and Sustainable Economies', link: process.env.PUBLIC_URL + '/cluster/c2.png' },
            { name: 'Islamic Civilization: Foundations and Institutions', link: process.env.PUBLIC_URL + '/cluster/c3.png' },
            { name: 'Bibliographic Capacity in Islamic Studies', link: process.env.PUBLIC_URL + '/cluster/c4.png' },
            { name: 'Islam, Reform and Global Affairs', link: process.env.PUBLIC_URL + '/cluster/c5.png' },
            { name: 'Islam and Applied Ethics', link: process.env.PUBLIC_URL + '/cluster/c6.png' },
            { name: 'Islamic Art, Architecture and Urbanity', link: process.env.PUBLIC_URL + '/cluster/c7.png' }
        ]
        return (
            <div id="cluster_popup" className="cluster_pop_page">
                <Header />
                <div className='container'>
                    <div className='top-contents'>
                        <div className="crumbs"><Link to='/'>Home</Link> / <Link to='/research/cluster'>Research Clusters</Link> / {this.state.data1 ? this.state.data1.data[0] ? this.state.data1.data[0].attributes ? this.state.data1.data[0].attributes.title ? this.state.data1.data[0].attributes.title : links : links : links : links}</div>
                        {/* <TopBar data={'data1'} /> */}
                    </div>
                    <div className='heading'>CIS Research Clusters</div>
                </div>
                <div className="pop_box container">

                    <div className="col-sm-5">
                        {cluster ?
                            <div className="left_panel">
                                {cluster.map((inst, index) => {
                                    let links = this.props.match.params.id.replace(/-/g, ' ')
                                    let linked = inst.name.replace(/ /g, '-')
                                    return (
                                        <div className="clusterlist">
                                            <div className="title">
                                                <span className="field-content">
                                                    <Link style={{ color: links === inst.name ? '#0A9CA8' : 'black' }} to={{ pathname: '/cluster_details/' + `${linked}` }}>
                                                        {inst.name}
                                                    </Link>
                                                </span>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>

                            : <List />
                        }
                    </div>
                    <div className="col-sm-7">
                        <div className='formrea clusterpage yourwork sub_work'>
                            {this.state.data1 ?
                                <div className="listing">
                                    <div className="heading2">{this.state.data1 ? this.state.data1.data[0] ? this.state.data1.data[0].attributes ? this.state.data1.data[0].attributes.title ? this.state.data1.data[0].attributes.title : links : links : links : links}</div>
                                    {console.log('props', links)

                                    }
                                    <div className='toggle-bars'>
                                        <button onClick={() => this.scrollToTargetAdjusted('overview')} style={{ backgroundColor: this.state.tab_sel === "overview" ? "#165E84" : "", color: this.state.tab_sel === "overview" ? "#fff" : "" }}>Overview</button>
                                        <button onClick={() => this.scrollToTargetAdjusted('member')} style={{ backgroundColor: this.state.tab_sel === "member" ? "#165E84" : "", color: this.state.tab_sel === "member" ? "#fff" : "" }}>Members</button>
                                        <button onClick={() => this.scrollToTargetAdjusted('project')} style={{ backgroundColor: this.state.tab_sel === "project" ? "#165E84" : "", color: this.state.tab_sel === "project" ? "#fff" : "" }}>Projects {'&'} Events</button>
                                        <button onClick={() => this.scrollToTargetAdjusted('pubs')} style={{ backgroundColor: this.state.tab_sel === "pubs" ? "#165E84" : "", color: this.state.tab_sel === "pubs" ? "#fff" : "" }}>Publications</button>
                                        <button onClick={() => this.scrollToTargetAdjusted('grants')} style={{ backgroundColor: this.state.tab_sel === "grants" ? "#165E84" : "", color: this.state.tab_sel === "grants" ? "#fff" : "" }}>Partnership {'&'} Grants</button>
                                        <button onClick={() => this.scrollToTargetAdjusted('theses')} style={{ backgroundColor: this.state.tab_sel === "theses" ? "#165E84" : "", color: this.state.tab_sel === "theses" ? "#fff" : "" }}>Student Theses</button>
                                    </div>
                                    {/* {this.state.tab_sel == 'overview' ? */}
                                    <div ref={this.refover} id='overview' className='cluster-detailed-info cluster-sub-details'>
                                        <h3>Overview</h3>
                                        {this.state.data1.data[0] ? <div>{this.state.data1.data[0].attributes.field_overview ? ReactHtmlParser(this.state.data1.data[0].attributes.field_overview.value) : "No data"}</div> : 'No data'}
                                    </div>
                                    {/* : ''} */}
                                    {/* {this.state.tab_sel === 'member' ? */}
                                    <div ref={this.refmember} id='member' className='cluster-sub-details'>
                                        <h3>Members</h3>
                                        {this.state.data1.data[0] ? <div>{this.state.data1.data[0].attributes.field_members_body ? ReactHtmlParser(this.state.data1.data[0].attributes.field_members_body.value) : "No data"}</div> : 'No data'}

                                    </div>
                                    {/* : ''} */}
                                    {/* {this.state.tab_sel === 'project' ? */}
                                    <div ref={this.refproj} id='project' className='cluster-sub-details'>
                                        <h3>Projects {'&'} Events</h3>
                                        {this.state.data1.data[0] ? <div>{this.state.data1.data[0].attributes.field_projects_events ? ReactHtmlParser(this.state.data1.data[0].attributes.field_projects_events.value) : "No data"}</div> : 'No data'}

                                    </div>
                                    {/* : ''} */}
                                    {/* {this.state.tab_sel === 'pubs' ? */}
                                    <div ref={this.refpub} id='pubs' className='cluster-sub-details'>
                                        <h3>Publications</h3>
                                        {this.state.data1.data[0] ? <div>{this.state.data1.data[0].attributes.field_publications_body ? ReactHtmlParser(this.state.data1.data[0].attributes.field_publications_body.value) : "No data"}</div> : 'No data'}

                                    </div>
                                    {/* : ''} */}
                                    {/* {this.state.tab_sel === 'grants' ? */}
                                    <div ref={this.refpartner} id='grants' className='cluster-sub-details'>
                                        <h3>Partnership {'&'} Grants</h3>
                                        {this.state.data1.data[0] ? <div>{this.state.data1.data[0].attributes.field_partnership_grants ? ReactHtmlParser(this.state.data1.data[0].attributes.field_partnership_grants.value) : "No data"}</div> : 'No data'}

                                    </div>
                                    {/* : ''} */}
                                    {/* {this.state.tab_sel === 'theses' ? */}
                                    <div ref={this.refthesis} id='theses' className='cluster-sub-details'>
                                        <h3>Student Theses</h3>
                                        {this.state.data1.data[0] ? <div>{this.state.data1.data[0].attributes.field_student_theses_body ? ReactHtmlParser(this.state.data1.data[0].attributes.field_student_theses_body.value) : "No data"}</div> : 'No data'}

                                    </div>
                                    {/* : ''} */}
                                    {/* {this.state.data1 ? this.state.data1.data[0].relationships.field_relevant_centers.data !== null ?
                                        <div>
                                            <div className="heading2">Relevant Centers</div>
                                            <div className="main-content">
                                                <div className="region region-content">
                                                    <div className="listings">
                                                        <div className="right_panel">
                                                        {this.state.data1.included ?
                                                            this.state.data1.included.filter(item => item.type === "taxonomy_term--research_center").map((inst, index) => {
                                                                return (
                                                                    <div className="clusterlist">
                                                                        <div className="title">
                                                                            <span className="field-content">
                                                                                <a target="_blank" href={inst.attributes.field_link.uri}>
                                                                                    {inst.attributes.name}<span><img className='cluster-next' src={next} /></span>
                                                                                </a>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            }):''}

                                                        </div>


                                                    </div>

                                                </div>
                                            </div>
                                        </div> : '' : ''
                                    } */}
                                    {/* {this.state.data1 && this.state.data1.data[0].relationships.field_cis_program.data.length !== 0 ?
                                        <div>
                                            <div className="heading2 cis-pgm">Relevant CIS Program</div>
                                            <div className="main-content">
                                                <div className="region region-content">
                                                    <div className="listings">
                                                        <div className="right_panel">
                                                            {this.state.data1.included?this.state.data1.included.filter(item => item.type === "taxonomy_term--cis_programs").map((inst, index) => {
                                                                return (
                                                                    <div className="clusterlist">
                                                                        <div className="title">
                                                                            <span className="field-content">
                                                                                <a target="_blank" href={inst.attributes.field_link.uri}>
                                                                                    {inst.attributes.name}<span><img className='cluster-next' src={next} /></span>
                                                                                </a>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            }):''}
                                                        </div>


                                                    </div>

                                                </div>
                                            </div>
                                        </div> : ''
                                    } */}
                                </div> : <List />}

                        </div>
                    </div>
                </div>
                <Footer />
            </div>

        )
    }
}

export default ClusterPopup;
